/**
 * Function that returns the correct noun according to the plural rules of the locale and `cardinalNumber`.
 * @param {number} cardinalNumber Cardinal number.
 * @param {object} pluralWordsMap Plural words depending on the amount.
 * @param {string} locale Locale.
 * @returns {string}
 */
export function makePlural(cardinalNumber, pluralWordsMap, locale = 'en-US') {
  const rule = new Intl.PluralRules(locale).select(cardinalNumber);
  return pluralWordsMap[rule] ?? '';
}
